<!--
 <table>
  <tr>
    <td>

    </td>
    <td>

      <ion-button expand="full" (click)="startScanner()" [hidden]="scanActive">
        <ion-icon name="barcode-outline"></ion-icon>
      </ion-button>
    </td>
  </tr>
 </table>
-->

<ion-row class="scan-button" [hidden]="!scanActive">
  <ion-col class="ion-no-padding">
    <ion-button expand="full" (click)="stopScanner()">Stop</ion-button>
  </ion-col>
</ion-row>
<div class="scan-container">
  <div class="scan-box" [hidden]="!scanActive"></div>
</div>
